import { render, staticRenderFns } from "./FrTermsOfUse.vue?vue&type=template&id=49c4bb2b&scoped=true"
import script from "./FrTermsOfUse.vue?vue&type=script&lang=js"
export * from "./FrTermsOfUse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "49c4bb2b",
  null
  ,true
)

export default component.exports